import { createSlice } from '@reduxjs/toolkit'

/**
 * Redux slice holding the currently active gateway entry.
 */
export const gatewaySlice = createSlice({
  name: 'gateway',

  initialState: {
    entry: null
  },

  reducers: {
    updateGateway: (state, action) => {
      state.entry = action.payload
    },

    resetGateway: state => {
      state.entry = null
    }
  }
})

/**
 * `updateGateway` sets the active gateway entry; `resetGateway` clears it back to `null`.
 */
export const { updateGateway, resetGateway } = gatewaySlice.actions

/**
 * Selects the currently active gateway entry.
 *
 * @param {Object} state - Redux state.
 * @returns {Object|null} Gateway entry, or `null` if none is active.
 */
export const gateway = state => state.gateway.entry
